<template>
  <ReportingSettings
    :available-filters="availableFilters"
    :default-title="$t('DEFAULT_INSIGHTS_TITLE')"
    :active-report="activeInsight"
    :report-type="reportType"
    :time-range="activeInsightTimeRange"
    :time-zone-id="activeInsightTimeZoneId"
    :translated-time-zone-id="activeInsightTranslatedTimeZoneId"
    :last-updated="activeInsightLastUpdated"
    :filter-criteria="activeInsightFilterCriteria"
    :quick-filters="insightsQuickFilters"
    form-name-for-user-settings="reportingFilterUserSettings"
    @dateRangeChange="$emit('dateRangeChange')"
    @saveReport="saveInsight"
    @deleteReport="deleteInsight"
    @duplicateReport="duplicateInsight"
    @refreshData="refreshInsightGridData"
    @onStartTour="$emit('onStartTour')"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import messages from './locales';
import { $ngStateService, utilities } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import ReportingSettings from '../../ReportingSettings/ReportingSettings';
import { INSIGHT_REPORT_TYPE } from '@/modules/reporting/store/state';
import analyticsMixinFactory from '@/core/mixins/analyticsMixinFactory';

export default {
  name: 'ReportingInsightsSettings',
  components: {
    ReportingSettings,
  },
  mixins: [analyticsMixinFactory('insights')],
  data() {
    return {
      reportType: Object.freeze(INSIGHT_REPORT_TYPE),
    };
  },
  computed: {
    ...mapGetters('reporting', [
      'availableFilters', 
      'activeInsight',
      'activeInsightTimeRange',
      'activeInsightTimeZoneId',
      'activeInsightTranslatedTimeZoneId',
      'activeInsightLastUpdated',
      'activeInsightFilterCriteria',
      'insightsQuickFilters'
    ]),
    isNewInsight() {
      return !this.activeInsight.id;
    },
  },
  methods: {
    ...mapActions('reporting', [
      'refreshInsightGridData',
      'saveReport',
      'deleteReport',
      'duplicateReport',
      'setSavedReportVisibility',
    ]),

    async saveInsight(visibleAccountWide) {
      const isNew = this.isNewInsight;
      if(isNew) {
        this.setSavedReportVisibility({
          reportType: INSIGHT_REPORT_TYPE,
          visibleAccountWide
        });
      }

      try {
        await this.saveReport(this.activeInsight);
      } catch (error) {
        utilities.errorHandler(error);
        return;
      }
      
      if(isNew) {
        utilities.showToaster('success', this.$i18n.t('INSIGHT_SAVE_SUCCESS'));
        this.routeToNewInsight();
      } else {
        utilities.showToaster('success', this.$i18n.t('INSIGHT_UPDATE_SUCCESS'));
      }

      document.title = this.activeInsight.name;
    },
    async deleteInsight() {
      try {
        await this.deleteReport(this.activeInsight.id);
        utilities.showToaster('success', this.$i18n.t('INSIGHT_DELETE_SUCCESS'));
        $ngStateService.go('dashboard.insights.default');
      } catch (error) {
        utilities.showToaster('error', this.$i18n.t('INSIGHT_DELETE_FAILED'));
      }
    },
    async duplicateInsight(visibleAccountWide) {
      this.setSavedReportVisibility({
        reportType: INSIGHT_REPORT_TYPE,
        visibleAccountWide
      });
      await this.duplicateReport(this.activeInsight);
      utilities.showToaster('success', this.$i18n.t('INSIGHT_DUPLICATE_SUCCESS'));      
      document.title = this.activeInsight.name;
      this.routeToNewInsight();
    },

    routeToNewInsight() {
      $ngStateService.go('dashboard.insights.viewInsight', {
        insightId: this.activeInsight.id
      });
    },
  },
  i18n: {
    locale: 'en',
    messages
  }
};
</script>

<style lang="scss">
</style>